import React from 'react';
import {
  Box,
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ThingInformation from './ThingInformation';
import { ROUTE_THING } from '../../constants';
import { useNavigate } from 'react-router-dom';
import ThingConfiguration from './ThingConfiguration';
import ThingData from './ThingData';
import useThingStore from '../../stores/ThingStore';
import IconButtonBox from '../../components/IconButtonBox';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const ThingInfoMain: React.FC = () => {
  const { tabIndex } = useThingStore();
  const navigate = useNavigate();

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <IconButtonBox
          icon={<KeyboardBackspaceIcon />}
          text='Back to thing list'
          onClick={() => navigate(ROUTE_THING)} />
      </Box>

      <CustomTabPanel value={tabIndex} index={0}>
        <ThingInformation />
      </CustomTabPanel>
      <CustomTabPanel value={tabIndex} index={1}>
        <ThingConfiguration />
      </CustomTabPanel>
      <CustomTabPanel value={tabIndex} index={2}>
        <ThingData />
      </CustomTabPanel>
    </Box>
  );
};

export default ThingInfoMain;
